module.exports = __webpack_public_path__ + "img/imp.0a6b4c1e.jpeg";